const query = `
{
    user(username: "moazamdev") {
      publication {
        posts(page: 0) {
          title
          brief
          slug
          cuid
          coverImage
          dateAdded
        }
      }
    }
  }`;
export default async function getData() {
	const response = await fetch("https://api.hashnode.com", {
		method: "post",
		headers: {
			"Content-Type": "application/json",
		},
		body: JSON.stringify({ query: query }),
	});
	return await response.json();
}
